<template>
    <div style="padding:1px;" v-if="shouldShow">
        <v-card elevation="2" @mouseover="isNew = false">
            <v-toolbar flat dense style="margin-bottom:-16px;">
                <v-toolbar-title>{{ title }}</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-icon :size="iconSize" v-if="isNew"
                    :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'">mdi-new-box</v-icon>

                <v-btn icon>
                    <v-icon :size="iconSize" v-on:click="toggleStarred" v-if="isStarred" color="#ffe234">mdi-star
                    </v-icon>
                    <v-icon :size="iconSize" v-on:click="toggleStarred" v-if="!isStarred">mdi-star-outline</v-icon>
                </v-btn>


                <!-- <v-switch v-model="isRead" color="var(--houseColor)" :label="switchLabel" inset hide-details></v-switch> -->

            </v-toolbar>
            <v-dialog v-model="dialog" :value="dialog" width="500">
                <template v-slot:activator="{ on, attrs }">
                    <v-banner id="mybanner" dense single-line>
                        <v-icon :size="iconSize" v-if="status != 'READ'"
                            :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'" slot="icon"
                            v-bind="attrs" v-on="on" v-on:click="hasBeenRead">mdi-email</v-icon>
                        <v-icon :size="iconSize" v-if="status == 'READ'"
                            :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'" slot="icon"
                            v-bind="attrs" v-on="on" v-on:click="isRead = true">mdi-email-open</v-icon>
                        <div v-bind="attrs" v-on="on">{{ message }}</div>
                    </v-banner>
                </template>
                <v-card class="pa-2" :class="($vuetify.theme.dark) ? 'dialogDark' : ''">
                    
                    <v-card elevation="-1" shaped outlined>
                        <v-card-text class="display-6">{{ message }}
                        </v-card-text>
                    </v-card>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialog = false"
                            :color="($vuetify.theme.dark) ? 'var(--darkSecondColor)' : 'var(--lightSecondColor)'"> Close
                        </v-btn>
                    </v-card-actions>
                </v-card>

            </v-dialog>
        </v-card>
    </div>
</template>

<style>
p {
    font-size: 16px;
}
</style>
<!-- Display the contents of a single transaction in here  -->
<script>
import RestResource from '@/RestResource';
const restResourceService = new RestResource();
export default {
    name: "NotificationCard",
    components: {
    },
    props: {
        tabSelection: Number,
        id: Number,
        dateAssigned: Date,
        passStatus: String,
        message: String,
        title: String,
        accountId: Number,
        passStarred: String,  // (one of ‘yes’ or ‘no’)
    },
    data: () => ({
        maxMessageLength: 80,
        dialog: false,
        iconSize: 28,
        isNew: false,
        isRead: false,
        isStarred: false,
        date: 0,
        status: null,
        returnedStatus: null,
    }),
    created: function () {
    },
    mounted() {
        this.setAttsFromProps();
    },
    watch: {
        passStatus() {
            this.hasBeenRead();
        }
    },
    computed: {
        shouldShow() {
            //New
            if (this.$props.tabSelection == 0) {
                if (!this.isStarred && this.status != "READ")
                    return true;
            }

            //All
            else if (this.$props.tabSelection == 1) {
                return true;
            }

            //Starred
            else if (this.$props.tabSelection == 2) {
                if (this.isStarred)
                    return true;
            }

            else return false;

            return false;

        },
        messageShortened() {
            if (this.$props.message.length < this.maxMessageLength)
                return message;

            let message = this.$props.message.substring(this.$props.message, this.maxMessageLength);
            message = message + "..."
            return message;
        },

        switchLabel() {
            if (this.isRead) return "Read"
            else return "New"
        },

    },
    methods: {
        setAttsFromProps() {
            if (this.$props.passStatus == 'UNREAD')
                this.isNew = true;

            if (this.$props.passStatus == 'UNREAD')
                this.isNew = true;

            this.status = this.$props.passStatus;

            if (this.$props.passStarred == 'yes')
                this.isStarred = true;
            else this.isStarred = false;

            this.date = this.$props.dateAssigned;
        },
        hasBeenRead() {
            //call restResource
            if(this.status=='READ')
                return;
            this.status = 'READ';
            restResourceService.postReadMessage(this.$props.id);
        },
        toggleStarred() {
            this.isStarred = !this.isStarred;
            //Post to backend
            restResourceService.postToggleStarMessage(this.$props.id);
        },
    },
};
</script>

<style scoped>
div.v-banner__wrapper #mybanner {
    padding: 0px !important;
}

#mybanner {
    padding: 0px !important;
}
</style>

